import ExcelJS from "exceljs";

export type FarmerKycUploadRow = Record<string, string>;

export function normalizeHeaderKey(header: string): string {
  return header
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_]/g, "");
}

/** Headers like "Status (Yes/No)" normalize to "status_yesno", not "status". */
export function statusFromRow(row: FarmerKycUploadRow): string {
  const direct = (row.status ?? "").trim();
  if (direct) return direct;
  const altKey = Object.keys(row).find(
    (k) => k === "status" || k.startsWith("status_")
  );
  return altKey ? (row[altKey] ?? "").trim() : "";
}

export function rowsToKycEnablePayload(rows: FarmerKycUploadRow[]) {
  return rows.map((row) => ({
    farmer_id: (row.farmer_id ?? "").trim(),
    status: statusFromRow(row).toLowerCase(),
  }));
}

export function parseWorksheetToRows(
  worksheet: ExcelJS.Worksheet
): FarmerKycUploadRow[] {
  const headerRow = worksheet.getRow(1);
  const colToKey: Record<number, string> = {};
  const maxCol = Math.max(headerRow.cellCount, headerRow.actualCellCount || 0);

  for (let col = 1; col <= maxCol; col++) {
    const key = normalizeHeaderKey(headerRow.getCell(col).text || "");
    if (key) colToKey[col] = key;
  }

  const rows: FarmerKycUploadRow[] = [];

  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber === 1) return;

    const rowData: FarmerKycUploadRow = {};
    let hasValue = false;

    for (let col = 1; col <= maxCol; col++) {
      const key = colToKey[col];
      if (!key) continue;
      const value = (row.getCell(col).text ?? "").trim();
      if (value) hasValue = true;
      rowData[key] = value;
    }

    if (hasValue) rows.push(rowData);
  });

  return rows;
}
